import { useEffect, useRef, useState } from "react";
import { useWallet } from "@aptos-labs/wallet-adapter-react";

// Header widget for BKFC pages: the BKFC wordmark plus, once an Aptos wallet
// is connected, the truncated address with a disconnect dropdown (mirroring
// the catgame email-chip pattern). Rendered only from Header's isBkfcPage
// branch — every route that renders a Header on those paths sits inside
// BkfcAptosProvider, so useWallet() is safe here and this component never
// mounts on an EVM flow.
export function BkfcHeaderWallet() {
  const { connected, account, wallet, disconnect } = useWallet();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const address = account?.address?.toString() ?? "";

  const handleDisconnect = async () => {
    setOpen(false);
    try {
      await disconnect();
    } catch (err) {
      console.error("BKFC disconnect error:", err);
    }
  };

  return (
    <>
      <img
        src="/images/bkfc/bkfc-wordmark.png"
        alt="BKFC Logo"
        className="h-[18px]"
      />

      {connected && address && (
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setOpen((prev) => !prev)}
            className="border-2 border-black px-2 min-h-[35px] text-xs font-bold text-black leading-none"
          >
            {address.slice(0, 5)}...{address.slice(-4)}
          </button>

          {open && (
            <div className="absolute right-0 top-full mt-2 w-56 bg-white rounded-md border shadow-lg z-50">
              <div className="w-[25px] h-[25px] bg-white rotate-45 rounded-lg border absolute top-[-12px] right-[12px] border-r-0 border-b-0"></div>
              <div className="relative px-4 pt-3 pb-2 border-b">
                <div className="text-sm font-bold text-[#1F1F1F]">
                  {wallet?.name ?? "Aptos wallet"}
                </div>
                <div className="mt-1 text-xs text-[#626262] break-all">
                  {address}
                </div>
              </div>
              <button
                onClick={handleDisconnect}
                className="w-full text-left px-4 py-3 hover:bg-gray-100 text-[#1F1F1F] font-medium"
              >
                Disconnect wallet
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
}
